module.exports = __webpack_public_path__ + "img/State=9.74fcde53.svg";